<template>
  <div>
    <div class="listing-type-one d-xl-flex flex-wrap justify-content-start">
      <div
        :class="class1"
        style="display:block!important;margin-bottom:30px;"
      ></div>
      <div class="one-right ml-4">
        <ul class="nostyle ul-button d-flex justify-content-center">
          <li>
            <button
              class="btn btn-primary btn-rounded"
              @click="openCreateReviewListPopup"
              style="font-size: 14px;"
            >
              リスト新規作成
            </button>
          </li>
        </ul>
      </div>
      <CreateReviewList
        v-if="showCreateReviewListPopup"
        :isEditing="false"
        @hideModal="hideModal"
      />
    </div>
    <!-- ends listing-type-one -->
  </div>
</template>

<script>
import CreateReviewList from './CreateReviewList.vue';
export default {
  name: 'ReviewList',
  components: { CreateReviewList },
  data() {
    return {
      showCreateReviewListPopup: false,
      class1:
        'one-left d-xl-flex align-items-center justify-content-center justify-content-md-start',
    };
  },
  computed: {},
  methods: {
    openCreateReviewListPopup() {
      this.showCreateReviewListPopup = true;
    },
    hideModal() {
      this.showCreateReviewListPopup = false;
    },
    createUser() {},
    openLink() {
      const link = `https://docs.google.com/presentation/d/1psjoG9M_vgwh51C6beXIadmRfik13NyxnjMX0MUNIxA/edit?usp=sharing`;
      window.open(link, '_blank');
    },
  },
};
</script>
<style scoped>
/* .listing-type-one{
   padding-bottom: 15px;
  } */

/* .client-listing-head .one-left .external-url{
    margin-left:5px;
    font-weight:bold;
    text-decoration:underline;
    color: #007bff;
    cursor:pointer
  } */
</style>
